import { Table } from 'antd';
import { useMemo } from 'react';
import { type IIdentifyLayerResult } from '../drawing/identify/IIdentifyResult.ts';
import { getAttributesColumnsFromFeatures } from './getAttributesColumnsFromFeatures.ts';

export interface IMapIdentifyLayerResultsProps {
  result: IIdentifyLayerResult;
  aliases?: Record<string, string>;
}

/**
 * Tabella read-only per i risultati di un singolo layer
 * interrogato. Le colonne sono dinamiche, costruite dagli
 * attributi delle feature con titoli da aliases.
 */
export function MapIdentifyLayerResults(props: IMapIdentifyLayerResultsProps) {
  const { result, aliases } = props;

  const columns = useMemo(
    () => getAttributesColumnsFromFeatures(result.features, aliases),
    [result.features, aliases],
  );

  return (
    <Table
      dataSource={result.features}
      columns={columns}
      rowKey={(_, index) => String(index)}
      size="small"
      pagination={{ pageSize: 10, hideOnSinglePage: true }}
      scroll={{ x: 'max-content' }}
    />
  );
}
